import React from 'react';
import lottery from '../../lottery';
import style from './FormattedPrizeMatches.scss';
var FormattedPrizeMatches = function (_a) {
    var matches = _a.matches;
    return React.createElement("span", { className: style['formatted-prize-matches'] }, lottery.number_descriptions.map(function (title, index) { return React.createElement("span", { className: matches.indexOf(index) > -1 ? style['match'] : null, key: index }, title); }));
};
export default FormattedPrizeMatches;
